import { createAction, props } from "@ngrx/store";

export const copyLanguage = createAction(
    '[Manage Languages] Copy Language',
    props<{ language: string }>()
)

export const copyLanguageSuccess = createAction(
    '[Manage Languages] Copy Language Success',
    props<{ response: any }>()
)

export const copyLanguageFailed = createAction(
    '[Manage Languages] Copy Language Failed',
    props<{ error: string }>()
)
